import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";

var IconCaution = function IconCaution(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.916,11.11,7.5.285a.577.577,0,0,0-1,0L.083,11.11a.588.588,0,0,0,.5.89H13.418A.588.588,0,0,0,13.916,11.11Zm-6.045-.531H6.128V8.816H7.871Zm0-2.939H6.128v-4.7H7.871Z",
      transform: "translate(0 0)",
      fill: "#eb7d3c"
    })
  }));
};

IconCaution.defaultProps = {
  viewBox: "0 0 14 12"
};
import styles from "@/styles/Form.module.scss";
import modalStyles from "@/styles/Modal.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ErrorMessage(_ref) {
  var msg = _ref.msg,
      inModal = _ref.inModal,
      processHeadingCaution = _ref.processHeadingCaution;
  if (!msg) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!inModal && !processHeadingCaution && /*#__PURE__*/_jsxs("span", {
      className: styles.errorMessage,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.iconCaution,
        children: /*#__PURE__*/_jsx(IconCaution, {})
      }), msg]
    }), inModal && /*#__PURE__*/_jsxs("h4", {
      className: modalStyles.errorMessageHeading,
      children: [/*#__PURE__*/_jsx("span", {
        className: modalStyles.iconCaution,
        children: /*#__PURE__*/_jsx(IconCaution, {})
      }), msg]
    }), processHeadingCaution && /*#__PURE__*/_jsxs("p", {
      className: processStyles.processHeadingCaution,
      children: [/*#__PURE__*/_jsx("span", {
        className: processStyles.iconCaution,
        children: /*#__PURE__*/_jsx(IconCaution, {})
      }), msg]
    })]
  });
}